<ng-container>
  <front-header
    [sticky]="false"
  />

  <div class="our-mission-container">
    <h1
      [title]="'Our mission' | trans"
      class="our-mission-title"
    >
      {{ 'Our mission' | trans }}
    </h1>

    <div
      [renderHtml]="'Our mission desc' | trans"
      class="our-mission-desc"
    ></div>
  </div>

  <div class="added-value-container">
    <div class="added-value-content">
      <h1 [title]="'Added value' | trans" class="added-value-title">
        {{ 'Added value' | trans }}
      </h1>

      <div class="added-value-steps">
        <div class="added-value-step-container">
          <div
            [renderHtml]="'Added value step 1' | trans"
            class="added-value-step-content"
          ></div>
        </div>

        <div class="added-value-step-container">
          <div
            [renderHtml]="'Added value step 2' | trans"
            class="added-value-step-content"
          ></div>
        </div>

        <div class="added-value-step-container">
          <div
            [renderHtml]="'Added value step 3' | trans"
            class="added-value-step-content"
          ></div>
        </div>

        <div class="added-value-step-container">
          <div
            [renderHtml]="'Added value step 4' | trans"
            class="added-value-step-content"
          ></div>
        </div>
      </div>
    </div>
  </div>


  <services-home-container/>

  <solutions-home-container/>

  <div class="our_commitments-container">
    <div class="our_commitments-bg"></div>

    <div class="our_commitments-content">
      <h3 [title]="'Our commitments' | trans" class="our_commitments-title">
        {{ 'Our commitments' | trans }}
      </h3>

      <div
        [renderHtml]="'Our commitments text' | trans"
        class="our_commitments-description"
      ></div>
    </div>
  </div>

  <div class="approach-container">
    <div class="approach-content">
      <h1
        [title]="'Our tailor-made approach' | trans"
        class="approach-title"
      >
        {{ 'Our tailor-made approach' | trans }}
      </h1>

      <div class="approach-cards-container">
        <div class="approach-card-content approach-analysis">
<!--          <fa-icon [icon]="icons['chartLine']"/>-->
          <span class="approach-card-count">1.</span>

          <div class="approach-card-core-content">
            <span [title]="'Analysis' | trans" class="approach-card-core-title">
              {{ 'Analysis' | trans }}
            </span>

            {{ 'Analysis desc' | trans }}
          </div>
        </div>

        <div class="approach-card-content approach-conception">
<!--          <fa-icon [icon]="icons['brain']"/>-->
          <span class="approach-card-count">2.</span>

          <div class="approach-card-core-content">
            <span [title]="'Conception' | trans" class="approach-card-core-title">
              {{ 'Conception' | trans }}
            </span>

            {{ 'Conception desc' | trans }}
          </div>
        </div>

        <div class="approach-card-content approach-achievement">
<!--          <fa-icon [icon]="icons['achievement']"/>-->
          <span class="approach-card-count">3.</span>

          <div class="approach-card-core-content">
            <span [title]="'Achievement' | trans" class="approach-card-core-title">
              {{ 'Achievement' | trans }}
            </span>

            {{ 'Achievement desc' | trans }}
          </div>
        </div>

        <div class="approach-card-content approach-optimisation">
<!--          <fa-icon [icon]="icons['optimisation']"/>-->
          <span class="approach-card-count">4.</span>

          <div class="approach-card-core-content">
            <span [title]="'Optimisation' | trans" class="approach-card-core-title">
              {{ 'Optimisation' | trans }}
            </span>

            {{ 'Optimisation desc' | trans }}
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
